package com.dignicate.web.domain

data class DocumentContent(
    val title: String,
    val metadata: Map<String, String>,
    val blocks: List<ContentBlock>
)

sealed interface ContentBlock {
    data class Heading(val level: Int, val text: String) : ContentBlock
    data class Paragraph(val text: String) : ContentBlock
    data class UnorderedList(val items: List<ListItem>) : ContentBlock
    data class CodeBlock(val language: String?, val code: String) : ContentBlock
}

sealed interface ListItem {
    data class Text(val text: String) : ListItem
    data class Link(val text: String, val url: String) : ListItem
}
